<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">HealthChecks</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Saúde dos serviços</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0 text-center">Serviço</th>
                    <th scope="col" class="border-0">UUID</th>
                    <th scope="col" class="border-0">Última notificação</th>
                    <th scope="col" class="border-0">Último estado</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(healthCheck, index) in healthChecks" :key="index">
                    <td class="text-center">{{ healthCheck.Name }}</td>
                    <td>{{ healthCheck.UUID }}</td>
                    <td>{{ GetLastPing(healthCheck) || "-" }}</td>
                    <td>
                      {{
                        GetHealthyStatus(GetLastPing(healthCheck, "IsHealthy"))
                      }}
                    </td>
                    <td>{{ healthCheck.Status.Name }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('HealthCheck', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenHealthCheck($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            class="dropdown-item"
                            v-if="
                              !healthCheck.IsExcluded &&
                              $isAuthorize('HealthCheck', 'Update')
                            "
                            href="#"
                            v-on:click="OpenHealthCheck($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            class="dropdown-item"
                            v-if="
                              !healthCheck.IsExcluded &&
                              $isAuthorize('HealthCheck', 'Delete')
                            "
                            href="#"
                            v-on:click="
                              ConfirmRemoveHealthCheck(
                                healthCheck.Name,
                                healthCheck.Id
                              )
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      healthChecks == undefined ||
                      healthChecks == null ||
                      healthChecks.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="modalTitle"
      id="mHealthCheck"
      size="md"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Name -->
        <ValidationObserver tag="form" ref="HealthCheckValidationForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <b-input
                  :class="validatedHealthCheckForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoHealthCheck.Name"
                ></b-input>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedHealthCheckForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="6" class="form-group">
              <b-form-group label="Modo">
                <b-form-radio-group
                  v-model="infoHealthCheck.Schedule.IsPeriod"
                  :disabled="isSeeing"
                >
                  <b-form-radio :value="true">Período</b-form-radio>
                  <b-form-radio :value="false"
                    >Avançado <i style="font-size: 9pt">(Cron)</i></b-form-radio
                  >
                </b-form-radio-group>
              </b-form-group>
            </d-col>

            <d-col md="6" class="form-group">
              <label>
                Feriados
                <i
                  class="far fa-question-circle ml-1"
                  style="font-size: 13px"
                  v-b-tooltip.hover.bottom
                  title="Quando habilitado, os feriados serão considerados e não haverá atraso ou notificação caso o ping não seja enviado durante um feriado."
                >
                </i>
              </label>
              <b-form-checkbox
                v-model="infoHealthCheck.Schedule.IncludeHolidays"
                :disabled="isSeeing"
                >{{
                  infoHealthCheck.Schedule.IncludeHolidays
                    ? "Habilitado"
                    : "Desabilitado"
                }}</b-form-checkbox
              >
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="12">
              <div class="form-group">
                <label>
                  Período de carência
                  <i
                    class="far fa-question-circle ml-1"
                    style="font-size: 13px"
                    v-b-tooltip.hover.bottom
                    title="Valor (em minutos) antes de um serviço atrasado ser notificado."
                  >
                  </i>
                </label>
                <ValidationProvider
                  rules="required|min_value:1"
                  v-slot="{ errors, invalid }"
                >
                  <b-input
                    :class="
                      validatedHealthCheckForm | showValidateError(invalid)
                    "
                    :disabled="isSeeing"
                    min="1"
                    step="1"
                    type="number"
                    v-model="infoHealthCheck.Schedule.GracePeriod"
                  >
                  </b-input>
                  <div
                    class="invalid-feedback d-block"
                    v-if="validatedHealthCheckForm"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </d-col>
          </d-form-row>

          <template v-if="infoHealthCheck.Schedule.IsPeriod">
            <d-form-row>
              <d-col md="12">
                <div class="form-group">
                  <label>
                    Período
                    <i
                      class="far fa-question-circle ml-1"
                      style="font-size: 13px"
                      v-b-tooltip.hover.bottom
                      title="Intervalo (em minutos) em que o serviço deve enviar o ping, caso não haja um ping nesse intervalo o status do serviço será considerado atrasado."
                    >
                    </i>
                  </label>
                  <ValidationProvider
                    rules="required|min:1"
                    v-slot="{ errors, invalid }"
                  >
                    <b-input
                      :class="
                        validatedHealthCheckForm | showValidateError(invalid)
                      "
                      :disabled="isSeeing"
                      min="1"
                      step="1"
                      type="number"
                      v-model="infoHealthCheck.Schedule.Period"
                    >
                    </b-input>
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedHealthCheckForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </div>
              </d-col>
            </d-form-row>
          </template>
          <template v-else-if="!infoHealthCheck.Schedule.IsPeriod">
            <d-form-row>
              <d-col md="12">
                <div class="form-group">
                  <label>
                    Cron
                    <i
                      class="far fa-question-circle ml-1"
                      style="font-size: 13px"
                      v-b-tooltip.hover.bottom
                      @click.stop="openCronGenerator"
                      title="Expressão Cron com 7 campos. Clique nessa interrogação para abrir o gerador online."
                    >
                    </i>
                  </label>
                  <ValidationProvider
                    rules="required|min:2"
                    v-slot="{ errors, invalid }"
                  >
                    <b-input
                      :class="
                        validatedHealthCheckForm | showValidateError(invalid)
                      "
                      :disabled="isSeeing"
                      type="text"
                      v-model="infoHealthCheck.Schedule.Cron"
                    >
                    </b-input>
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedHealthCheckForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </div>
              </d-col>
            </d-form-row>
          </template>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveHealthCheck()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ hOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            class="form-control"
            placeholder="Nome"
            type="text"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="12" class="form-group">
          <d-select v-model="filter.IsExcluded" :value="null">
            <option :value="true" selected>Removidos</option>
            <option :value="null" selected>Ativos</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('HealthCheck', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo health check"
      v-b-tooltip.hover
      v-on:click="OpenHealthCheck($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";

export default {
  name: "healthCheck",
  data: function () {
    return {
      countFilter: 0,
      fields: [],
      healthChecks: [],
      HealthCheckTypes: [],
      filter: {
        Description: null,
        IsExcluded: null,
      },
      idHealthCheck: 0,
      infoHealthCheck: {
        Id: 0,
        Name: "",
        UUID: "",
        Schedule: {
          Cron: null,
          GracePeriod: 1,
          Id: 0,
          IncludeHolidays: true,
          IsPeriod: true,
          Period: 0,
        },
        Status: {
          Id: 0,
          Name: "",
          Code: null,
        },
        PingHistory: [],
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      modalTitle: "Novo HealthCheck",
      hOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      selected_field: null,
      validatedHealthCheckForm: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListHealthCheck();
    },
    "pagination.RowsPerPage": function () {
      this.ListHealthCheck();
    },
  },
  beforeMount() {
    this.ListHealthCheck();
  },
  created() {
    // this.ListHealthCheckType();
  },
  mounted() {
    this.ListHealthCheck();
  },
  methods: {
    GetLastPing: function (healthCheck, field = "CreatedDate") {
      if (
        healthCheck.PingHistory != null &&
        healthCheck.PingHistory.length > 0
      ) {
        const ping = healthCheck.PingHistory.pop();
        return ping[field];
      }
    },
    GetHealthyStatus: function (isHealthy) {
      if (isHealthy === true) return "Saudável";
      if (isHealthy === false) return "Não-Saudável";
      return "-";
    },
    OpenHealthCheck: function (e, i, view) {
      e.preventDefault();
      this.validatedHealthCheckForm = false;
      this.ResetInfoHealthCheck();

      if (view == undefined && i != undefined) {
        // Edit
        this.hOpened = i;
        this.idHealthCheck = this.healthChecks[i].Id;
        this.isSeeing = false;
        this.modalTitle = `Editar HealthCheck [${this.healthChecks[i].UUID}]`;
        this.GetHealthCheck();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.hOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Novo HealthCheck";
        this.ResetInfoHealthCheck();
      } else {
        // View
        this.hOpened = i;
        this.idHealthCheck = this.healthChecks[i].Id;
        this.isSeeing = true;
        this.modalTitle = `Detalhes do HealthCheck [${this.healthChecks[i].UUID}]`;
        this.GetHealthCheck();
      }
      this.$bvModal.show("mHealthCheck");
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListHealthCheck();
    },
    ResetFilter: function () {
      this.filter = {
        Description: null,
        IsExcluded: null,
      };
      this.ListHealthCheck();
    },
    ResetInfoHealthCheck: function () {
      this.infoHealthCheck = {
        Id: 0,
        Name: "",
        UUID: "",
        Schedule: {
          Cron: null,
          GracePeriod: 1,
          Id: 0,
          IncludeHolidays: true,
          IsPeriod: true,
          Period: 0,
        },
        Status: {
          Id: 0,
          Name: "",
          Code: null,
        },
        PingHistory: [],
      };
    },
    SaveHealthCheck: function () {
      this.validatedHealthCheckForm = true;
      this.$refs.HealthCheckValidationForm.validate().then((isValid) => {
        if (isValid) {
          if (!this.infoHealthCheck.Schedule.IsPeriod) {
            let cronValidator = require("cron-expression-validator");
            let isCronValid = cronValidator.isValidCronExpression(
              this.infoHealthCheck.Schedule.Cron
            );
            if (!isCronValid) {
              this.$makeToast(
                "A expresão Cron digitada é inválida.",
                "warning",
                "Cron inválido"
              );
              return;
            }
          }
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.hOpened == null) {
            // Add
            this.$store
              .dispatch("AddHealthCheck", this.infoHealthCheck)
              .then(() => {
                this.$makeToast(
                  "O HealthCheck foi cadastrado com sucesso.",
                  "success",
                  "HealthCheck cadastrado"
                );
                this.ListHealthCheck();
                this.$bvModal.hide("mHealthCheck");
              })
              .catch((error) => {
                this.$makeToast(
                  "Tente novamente mais tarde.",
                  "danger",
                  "Erro ao criar HealthCheck",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateHealthCheck", this.infoHealthCheck)
              .then(() => {
                this.$makeToast(
                  "O HealthCheck foi atualizado.",
                  "success",
                  "Atualizado"
                );
                this.ListHealthCheck();
                this.$bvModal.hide("mHealthCheck");
              })
              .catch((error) => {
                this.$makeToast(
                  "Erro ao atualizar o HealthCheck, tente novamente.",
                  "danger",
                  "Erro ao modificar HealthCheck",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetHealthCheck: function () {
      if (this.idHealthCheck != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetHealthCheck", { id: this.idHealthCheck })
          .then((response) => {
            this.infoHealthCheck = response;
          })
          .catch((error) => {
            this.$makeToast(
              "Um erro ocorreu ao carregar o HealthCheck",
              "danger",
              "Erro ao carregar o HealthCheck",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListHealthCheck: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.IsExcluded": this.filter.IsExcluded,
        "Object.Name": this.filter.Name,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListHealthCheck", { params: data })
        .then((response) => {
          this.healthChecks = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os HealthChecks. Tente novamente.",
            "danger",
            "Erro ao listar os HealthChecks",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmRemoveHealthCheck: function (description, id) {
      this.$makeMsgBox(
        `Deseja remover "${description}" ?`,
        "Confirmar",
        this.DeleteHealthCheck,
        id
      );
    },
    DeleteHealthCheck: function (id) {
      this.$store
        .dispatch("DeleteHealthCheck", { id: id })
        .then(() => {
          this.$makeToast(
            "O HealthCheck foi removido com sucesso.",
            "success",
            "Removido com sucesso"
          );
          this.ListHealthCheck();
          this.$bvModal.hide("mHealthCheck");
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente.",
            "danger",
            "Erro ao remover HealthCheck",
            error
          );
        });
    },
    openCronGenerator: function () {
      window.open("https://en.rakko.tools/tools/88/");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/healthChecks.vue